import type { BasicScene } from '@/three/basicScene';
import type { SelectableObject } from '@/three/selectableObject';
import { atom } from 'nanostores';

export const $basicScene = atom<BasicScene | null>(null);

export function setBasicScene(scene: BasicScene | null) {
  $basicScene.set(scene);
}

export function deleteSelectedObjectsInScene() {
  $basicScene.get()?.deleteSelectedObjects();
}

export function placeObjectInScene(sceneObject: SelectableObject) {
  $basicScene.get()?.placeSceneObject(sceneObject);
}
